module.exports = __webpack_public_path__ + "img/Radlader.3ada7901.svg";